import React from 'react';
import ProductOverview from '../../product-overview/ProductOverview';
import product from '../all-gear.json';

const MenUALongSleeve = () => {
	return (
		<React.Fragment>
			<ProductOverview
				name={product.allGear[10].productName}
				color={product.allGear[10].color}
				size={product.allGear[10].sizes}
				price={product.allGear[10].price}
				img={product.allGear[10].img}
				miniImg1={product.allGear[10].miniImg1}
				miniImg2={product.allGear[10].miniImg2}
				miniImg3={product.allGear[10].miniImg3}
			/>
		</React.Fragment>
	);
};

export default MenUALongSleeve;
